<h2>School Details</h2>

@if (errorMessage) {
  <div class="error-message">
    <app-error-summary [error]="errorMessage" [status]="errorStatus"></app-error-summary>
  </div>
}

@if (!errorMessage) {
  @if (demographic$ | async; as demographic) {
    <dl class="nhsuk-summary-list">
      <div class="nhsuk-summary-list__row">
        <dt class="nhsuk-summary-list__key">Current School</dt>
        <dd class="nhsuk-summary-list__value">{{ demographic.currentSchoolName }}</dd>
      </div>

      <div class="nhsuk-summary-list__row">
        <dt class="nhsuk-summary-list__key">Current School Local Authority</dt>
        <dd class="nhsuk-summary-list__value">{{ demographic.currentSchoolLocalAuthorityName }}</dd>
      </div>

      <div class="nhsuk-summary-list__row">
        <dt class="nhsuk-summary-list__key">Current School Start Date</dt>
        <dd class="nhsuk-summary-list__value">{{ demographic.currentSchoolStartDate | date: 'dd/MM/yyyy' }}</dd>
      </div>
    </dl>
  } @else {
    <app-loading-spinner />
  }
}
